package com.anjuros.website.templates.template6.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.anjuros.website.components.shared.AnjurosText
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.components.shared.MenuIcon
import com.anjuros.website.templates.template1.util.ScrollListener
import com.anjuros.website.templates.template6.modules.Template6Section
import com.anjuros.website.templates.template6.modules.Template6Theme
import com.anjuros.website.templates.template6.modules.getColor
import com.anjuros.website.templates.template6.styles.CompanyColorVar
import com.anjuros.website.templates.template6.styles.Template6HeaderTextStyle
import com.anjuros.website.templates.template6.styles.Template6NavigationItemStyle
import com.anjuros.website.templates.template6.util.Template6CompanyDetails
import com.anjuros.website.templates.template6.util.Template6Constants
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.TextDecorationLine
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.scale
import com.varabyte.kobweb.compose.ui.modifiers.setVariable
import com.varabyte.kobweb.compose.ui.modifiers.textDecorationLine
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.breakpoint.displayIfAtLeast
import com.varabyte.kobweb.silk.style.breakpoint.displayUntil
import com.varabyte.kobweb.silk.style.toModifier
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template6Header(
    onMenuCLicked: () -> Unit = {}
) {

    var border by remember { mutableStateOf(0.px) }
    var scale by remember { mutableStateOf(1.0f) }
    ScrollListener { isTop ->

        border = if (isTop) 0.px else 1.px
        scale  = if(isTop) 1.0f else 0.8f
    }

    Box(
        modifier = Modifier.fillMaxWidth()
            .height(60.px)
            .border(
                width = border,
                color = Template6Theme.Primary.getColor(),
                style = LineStyle.Solid
            )
            .backgroundColor(Colors.White)
    ) {
        Row(
            modifier = Modifier.fillMaxWidth()
                .margin(topBottom = 0.px).align(Alignment.CenterEnd),
            horizontalArrangement = Arrangement.SpaceBetween,
            verticalAlignment = Alignment.CenterVertically
        ) {

            Template6LeftSide(
                scale = scale
            ) { onMenuCLicked() }
            Template6RightSide()
        }
    }
}

@Composable
fun Template6LeftSide(
    scale:Float,
    onMenuCLicked: () -> Unit
) {
    Row(modifier = Modifier.fillMaxHeight()
        .margin(topBottom = 0.px),
        verticalAlignment = Alignment.CenterVertically) {

        MenuIcon(
            modifier = Modifier
                .displayUntil(Breakpoint.LG)
                .margin(left = 15.px, top=0.px, bottom = 0.px)
                .align(Alignment.CenterVertically)
                .color(Template6Theme.Primary.getColor())
                .onClick { onMenuCLicked() }
        )
        Box(
            modifier = Modifier
                .fillMaxHeight(),
            contentAlignment = Alignment.Center
        ) {
            P(
                attrs = Template6HeaderTextStyle.toModifier()
                    .margin(topBottom = 0.px, leftRight = 15.px)
                    .align(Alignment.Center)
                    .fontFamily(Template6Constants.FONT_FAMILY)
                    .scale(scale)
                    .transition(Transition.of("scale", 1500.ms, delay = 300.ms))
                    .fontWeight(FontWeight.Bold)

                    .color(Template6Theme.Primary.getColor())
                    .toAttrs()
            ) {
                AnjurosText(Template6CompanyDetails.CLIENTS_COMPANY_INFO)

            }
        }
    }
}

@Composable
fun Template6RightSide() {
    val color = Template6Theme.Secondary.getColor()
    Row(
        modifier = Modifier
            .displayIfAtLeast(Breakpoint.LG), horizontalArrangement = Arrangement.Center
    ) {

        Template6Section.entries.toTypedArray().forEach { section ->
            Link(
                modifier = Modifier
                    .textDecorationLine(TextDecorationLine.None),
                path = section.path
            ) {
                P(
                    attrs = Template6NavigationItemStyle.toModifier()
                        .setVariable(CompanyColorVar,color)
                        .padding(right = 30.px)
                        .margin(topBottom = 0.px)
                        .fontFamily(Template6Constants.FONT_FAMILY)
                        .fontSize(18.px)
                        .toAttrs()
                ) {
                    Text(LocalText(section.title))

                }
            }

        }

    }
}